import fetch from 'utils/fetch'

export const getProcessingList = params => {
    return fetch({
        url: '/channel/task',
        data: params,
    })
}

export default {
    getProcessingList,
}
